import { createApi } from '@reduxjs/toolkit/query/react';
import { ReducerPaths } from '../../constants/reducerPaths';
import { baseQuery } from '../../utils/baseQuery';
import { sendReferralRequest } from './mutations';
import { getCandidateReferrals } from './queries';

export const candidateReferralsApi = createApi({
  reducerPath: ReducerPaths.CANDIDATE_REFERRALS,
  baseQuery,
  tagTypes: ['CandidateReferrals'],
  endpoints: (builder) => ({
    sendReferralRequest: sendReferralRequest(builder),
    getCandidateReferrals: getCandidateReferrals(builder),
  }),
});

export const {
  useSendReferralRequestMutation,
  useGetCandidateReferralsQuery,
  useLazyGetCandidateReferralsQuery,
} = candidateReferralsApi;
